const {escapeRegExp} = require('lodash');

module.exports = (debugEnv, namespace) => {
  namespace = escapeRegExp(namespace);
  if (!debugEnv) {
    return namespace;
  } else if (!debugEnv.split(',').includes(namespace)) {
    return `${debugEnv},${namespace}`;
  } else {
    return debugEnv;
  }
};
